import { useLocation } from 'react-router';

export type Area = 'candidate' | 'employer' | 'recruiter' | 'admin';

/** The dashboard area the current page lives in, e.g. "/employer". Shared pages use it to build links. */
export function useAreaBase(): `/${Area}` {
  const segment = useLocation().pathname.split('/')[1];
  const area: Area = segment === 'candidate' || segment === 'recruiter' || segment === 'admin' ? segment : 'employer';
  return `/${area}`;
}
